import { defineStore } from 'pinia'
import { ref } from 'vue'

interface PoshmarkUser {
  username: string
  userID: string
}

export const usePoshmarkUser = defineStore('PoshmarkUserStore', () => {
  const userID = ref<string | null>(null)
  const username = ref<string | null>(null)

  const setUser = (user: PoshmarkUser) => {
    username.value = user.username
    userID.value = user.userID
  }
  return { userID, username, setUser }
})
